<template>
  <ChartContainer class="d-flex flex-column" :params.sync="params">
    <v-card-title class="flex-grow-0">
      <v-icon class="pl-3 pr-4">mdi-account-box</v-icon>
      Người dùng theo thời điểm trong ngày
    </v-card-title>
    <v-card-text class="flex-grow-1 full-width full-height">
      <ChartLoadingContainer :loading="loading">
        <div>
          <div v-for="n in 24" :key="n" class="d-flex">
            <div
              v-for="m in 7"
              :key="`${m - 1}-${n - 1}`"
              class="heat-item-container"
            >
              <div
                class="heat-item"
                :style="{
                  'background-color': getColorByValue(
                    dashboard.data[`${m - 1}-${n - 1}`]
                  ),
                }"
                :title="
                  `Lượt truy cập: ${$n(dashboard.data[`${m - 1}-${n - 1}`])}`
                "
              >
              </div>
            </div>
            <div class="heat-item-container heat-text text-center">
              {{ n % 2 === 1 ? itemsHour[Math.floor(n / 2)] : '' }}
            </div>
          </div>
          <div class="d-flex">
            <div
              v-for="m in 7"
              :key="`${m}`"
              class="heat-item-container heat-text text-truncate text-center"
              :title="itemsDay[m - 1]"
            >
              {{ itemsDay[m - 1] }}
            </div>
            <div class="heat-item-container heat-text text-center"> </div>
          </div>
          <div class="d-flex">
            <div
              v-for="color in colorRange"
              :key="`${color}`"
              class="mr-1"
              :style="{
                'background-color': color,
                height: '20px',
                width: '100px',
              }"
            >
            </div>
          </div>
          <div class="d-flex">
            <div>1</div>
            <div
              v-for="(value, i) in valueRange"
              :key="`${i}`"
              :style="{
                height: '20px',
                'text-align': 'right',
                width: '100px',
              }"
            >
              {{ $n(value) }}
            </div>
          </div>
        </div>
      </ChartLoadingContainer>
    </v-card-text>
  </ChartContainer>
</template>

<script>
import ChartLoadingContainer from '@components/chart/ChartLoadingContainer.vue'
import ChartContainer from '../ChartContainer.vue'
import sdk from '@service/auth-sdk'
import { debounce, getChartColor } from '@utils'
export default {
  components: {
    ChartLoadingContainer,
    ChartContainer,
  },
  props: {},
  data: () => ({
    params: { type: '7days' },
    loading: false,
    itemsDay: ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'],
    itemsHour: [
      '12am',
      '2am',
      '4am',
      '6am',
      '8am',
      '10am',
      '12pm',
      '2pm',
      '4pm',
      '6pm',
      '8pm',
      '10pm',
    ],
    colorRange: [
      getChartColor(4),
      getChartColor(3),
      getChartColor(2),
      getChartColor(1),
    ],
    valueRange: [],
    dashboard: { data: {}, max: 0 },
  }),
  watch: {
    params: {
      handler: debounce(function() {
        this.fetchData()
      }, 100),
      deep: true,
    },
  },
  created() {
    this.fetchData()
  },
  computed: {},
  methods: {
    async fetchData() {
      this.loading = true
      const res = await sdk.request({
        url: '/dashboard/traffic-per-hour',
        params: this.params,
      })
      this.dashboard = res.data
      this.setRangeValue(res.data.max)
      this.loading = false
    },
    setRangeValue(max = 1) {
      if (max <= 1) {
        this.valueRange = [1, 1, 1, 1]
        return
      }
      if (max < 3) {
        this.valueRange = [1, 1, 2, 2]
        return
      }
      if (max < 4) {
        this.valueRange = [1, 2, 2, 3]
        return
      }
      this.valueRange = [
        Math.floor(max / 4),
        Math.floor(max / 2),
        Math.floor((max / 4) * 3),
        max,
      ]
    },
    getColorByValue(value) {
      if (value === 0) {
        return '#DDDDDD'
      }
      if (value === 1 && value === this.dashboard.max) {
        return this.colorRange[3]
      }
      let colorIndex = 0
      for (let index = 0; index < this.valueRange.length; index++) {
        const element = this.valueRange[index]
        if (value >= element) {
          colorIndex = index
        } else {
          break
        }
      }
      return this.colorRange[colorIndex]
    },
  },
}
</script>

<style scoped>
.heat-item-container {
  width: 12.5%;
  height: 20px;
  padding: 2px;
  display: inline-block;
  line-height: 20px;
}
.heat-item {
  height: 100%;
  width: 100%;
}
.heat-text {
  white-space: nowrap;
  margin: auto;
  vertical-align: middle;
  line-height: 16px;
}
</style>
